import api from "@/lib/api";

// Starts a Mollie (iDEAL) checkout for a listing action and redirects the browser.
export async function startCheckout(lookup_key, product_id) {
  const origin_url = window.location.origin;
  const { data } = await api.post("/payments/checkout", { lookup_key, product_id, origin_url });
  window.location.href = data.checkout_url;
}
